import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
interface usuario {
  id: number;
  nombre: string;
  apellido_paterno: string;
  apellido_materno: string;
  email: string;
  telefono: string;
  tipo_usuario_id: number;
  platform: "";
  profile: string;
  area: string;
  rfc: null;
  aseguradora: string;
  no_cliente: string;
  username: string;
  fc_clave_asegurado: string;
  subscription_channel: string;
  numero_asegurado: string;
  fi_asignacion: number;
  fi_seleccion: number;
  fc_avatar: string;
}
const usuarioVacio = {
  id: null,
  nombre: "",
  apellido_paterno: "",
  apellido_materno: "",
  email: "",
  telefono: "",
  tipo_usuario_id: null,
  platform: null,
  profile: "",
  area: "",
  rfc: null,
  aseguradora: "",
  no_cliente: "",
  username: "",
  fc_clave_asegurado: "",
  subscription_channel: "",
  numero_asegurado: "",
  fi_asignacion: 0,
  fi_seleccion: 0,
  fc_avatar:
    "https://protec-amex.s3.amazonaws.com/amexprod/usuarios/5/avatar.jpeg",
};

export interface UiState {
  token: string;
  usuario: usuario;
  etapaActual: number;
  fc_sub_etapa: string;
  valida: boolean;
  menu: boolean;
  fi_producto_seleccionado: number;
  isLoading: boolean;
  isAuthenticated: boolean;
  error: string;
  roles: string[];
}

const initialState: UiState = {
  token:
    typeof window !== "undefined"
      ? localStorage.getItem("app_token")
        ? localStorage.getItem("app_token")
        : ""
      : "",
  usuario: usuarioVacio,
  etapaActual: 0,
  fc_sub_etapa: "prueba",
  valida: true,
  menu: true,
  fi_producto_seleccionado: 0,
  isLoading: true,
  isAuthenticated: false,
  error: "",
  roles: [],
};

export const uiSlice = createSlice({
  initialState,
  name: "ui",
  reducers: {
    decrement: (state) => {
      state.usuario.id -= 1;
    },
    incrementByAmount: (state, action: PayloadAction<number>) => {
      state.usuario.id += action.payload;
    },
    iniciarSesion: (state, action: PayloadAction<usuario>) => {
      state.usuario = action.payload;
      state.valida = false;
    },
    agregarToken: (state, action: PayloadAction<any>) => {
      state.token = action.payload;
    },
    cambiarEtapa: (state, action: PayloadAction<any>) => {
      console.log("pruebaX", action.payload);
      state.etapaActual = action.payload.etapaActual;
      state.fc_sub_etapa = action.payload.fc_sub_etapa;
    },
    cambiaValida: (state, action: PayloadAction<number>) => {
      state.valida = true;
    },
    cerrarMenu: (state, action: PayloadAction<number>) => {
      state.menu = !state.menu;
    },
    agregarAvatar: (state, action: PayloadAction<string>) => {
      state.usuario.fc_avatar = action.payload;
    },
    setUsuario: (state, action) => {
      state.usuario = action.payload;
      state.valida = false;
    },
    setRoles: (state, action) => {
      state.roles = action.payload;
    },
  },
});

export const {
  iniciarSesion,
  cambiarEtapa,
  agregarToken,
  cambiaValida,
  cerrarMenu,
  agregarAvatar,
  setRoles,
  setUsuario,
} = uiSlice.actions;

export default uiSlice.reducer;
